import {
  doc,
  getDoc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db, dbCentral } from "../config/FirebaseConfig.js"; // Import the Firebase setup
import Icon1 from "../icons/Icon.js";
import { useState } from "react";

import SecondaryButton from "../buttons/SecondaryButton";
import SmallSpinner from "../loading/SmallSpinner.js";
import moment from "moment";

import { hi } from "date-fns/locale";
import dayjs from "dayjs";
export const formatToCentimes = (value) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

// Save organization data to Firestore
export async function saveOrg(orgData) {
  const docRef = doc(db, "org", orgData.id);
  await setDoc(docRef, orgData); // Save the plain object directly
}

// Get organization by ID
export async function getOrgById(id) {
  const docRef = doc(dbCentral, "org", id);
  const docSnapshot = await getDoc(docRef);
  if (docSnapshot.exists()) {
    return { id: id, ref: docRef, ...docSnapshot.data() }; // Return plain object with document reference and ID
  }
  return null; // Return null if no document exists
}

// Transform clients into a DataGrid-friendly format
export function transformClientsToTable(
  clientss,
  client_alerts = [],
  tab = "constructor"
) {
  // Define columns for DataGrid, customize based on your data structure

  let clients = [...clientss];
  if (tab === "constructor") {
    // only constructor
    clients = clients.filter((client) => client.client_type === "constructor");
  } else if (tab === "architect") {
    // only architect
    clients = clients.filter((client) => client.client_type === "architect");
  }

  const columns = [
    { field: "id", headerName: "ID", width: 200 },

    {
      field: "name",
      headerName: "Nom",
      flex: 1,

      renderCell: (params) => {
        let client_type = params.row.client_type;
        let row_id = params.id;
        let color_style = client_alerts.includes(row_id)
          ? "text-red-500 bg-red-100 mt-2"
          : client_type === "constructor"
          ? "text-indigo-500 bg-indigo-50"
          : params.value === "Clients particuliers"
          ? "text-purple-500 bg-purple-50"
          : "text-blue-400  bg-blue-50";
        return (
          <div className="flex flex-row items-center">
            <div>
              <div
                className={`inline-flex h-6 items-center rounded-full px-2 py-1 flex-row ${color_style} font-light gap-1`}
              >
                {client_alerts.includes(row_id) && (
                  <span className="flex items-center justify-center ">
                    <Icon1 icon_name="warning" size={18} fill="red" />
                  </span>
                )}
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "email", headerName: "Email", flex: 2 },

    { field: "ville", headerName: "Ville", flex: 1 },
    {
      field: "date",
      headerName: "Création",
      flex: 1,
      renderCell: (params) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = clients.map((client, index) => ({
    id: client.id || index + 1, // Use client's ID or default index
    ref: client.ref || null, // Include client's document reference
    name: client.name || "",
    email: client.email || "",
    date: client.creation_date, // Use client's creation date or default
    client_type: client.client_type || "", // Use client's type or default
    ville: client.infos?.ville || "", // Use client's city or default
  }));

  rows = rows.sort((a, b) => {
    return a.name.trim().localeCompare(b.name.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform clients into a DataGrid-friendly format
export function transformMastersToTable(
  masters,
  workspaceData,
  handleSwitchWorkspace,
  workspaces = []
) {
  // Define columns for DataGrid, customize based on your data structure
  const columns = [
    { field: "id", headerName: "ID", flex: 1 },

    {
      field: "name",
      headerName: "Nom",
      flex: 1,

      renderCell: (params) => {
        let row_id = params.id;

        return (
          <div className="flex flex-row items-center">
            <div>
              <div
                className={`inline-flex h-6 items-center rounded-full px-2 py-1 flex-row font-light gap-1`}
              >
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "phone", headerName: "Téléphone", flex: 1 },

    { field: "ville", headerName: "Ville", flex: 1 },
    {
      field: "date",
      headerName: "Création",
      flex: 1,
      renderCell: (params) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Changer",
      flex: 1,
      renderCell: (params) => {
        const state = params.value;
        return (
          <div className="flex flex-row items-center h-full  ">
            {state === "current" ? (
              <div className="  text-white bg-teal-300 px-2 text-h3  w-fit  flex rounded-full h-6 items-center">
                Actuel
              </div>
            ) : (
              <SecondaryButton
                className="w-fit"
                onClick={(e) => {
                  handleSwitchWorkspace(state);
                }}
              >
                Changer
              </SecondaryButton>
            )}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  const rows = masters.map((master, index) => ({
    id: master.id || index + 1, // Use client's ID or default index
    ref: master.ref || null, // Include client's document reference
    name: master.name || "",
    email: master.infos?.email || "",
    phone: master.infos?.phone || "",
    date: master.creation_date, // Use client's creation date or default
    ville: master.infos?.ville || "", // Use client's city or default
    action:
      workspaceData.master_id === master.id
        ? "current"
        : workspaces.find((workspace) => workspace.master_id === master.id)?.id, // Use client's type or default
  }));

  return { rows, columns }; // Return rows and columns for the DataGrid
}

export function isArchived(carnet, orgData) {
  if (!orgData) {
    console.error("isArchived: orgData is null");
    return false;
  } else if (!carnet.visions) {
    return false;
  } else {
    const vision = carnet.visions.find(
      (vision) => vision.org_id === orgData.id
    );
    if (vision) {
      if (vision.state === "archived") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
    return false;
  }
  return false;
}

export function intToHexColor(intColor) {
  return `#${(intColor >>> 0).toString(16).slice(-6)}`;
}

export function isColorTooDark(hexColor) {
  // Remove the "#" if present
  hexColor = hexColor.replace("#", "");

  // Convert hex to RGB
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);

  // Calculate the luminance using the relative luminance formula
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // Return true if the luminance is below a threshold (128 is a common midpoint)
  return luminance < 170;
}

export function adjustColorOpacity(hex, alpha) {
  // Helper function to convert hex to RGBA
  function hexToRgba(hex, alpha) {
    // Remove the '#' if present
    hex = hex.replace("#", "");
    // Parse the hex color into RGB
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Ensure alpha is between 0 and 1
  alpha = Math.max(0, Math.min(1, alpha));

  return hexToRgba(hex, alpha);
}

function getStatus(list_visions, realisee, orgData) {
  let org_state = "";
  let label = "";
  for (const vision of list_visions) {
    if (vision.org_id === orgData.id) {
      org_state = vision.state;
    }
  }

  if (org_state === "archived") {
    label = "Archivé";
  } else if (org_state === "current") {
    label = realisee ? "Réalisé" : "A venir";
  } else if (org_state === "deleted") {
    label = "Supprimé";
  }
  return label;
}

export function transformCarnetsToTable(
  allcarnets = [],
  activetab = "current",
  orgData,
  userData,
  openTag,
  searchValue,
  year,
  searchCarnets
) {
  try {
    if (searchValue !== "") {
      allcarnets = allcarnets.filter((carnet) =>
        carnet.name.includes(searchValue)
      );
    }

    if (activetab === "current") {
      allcarnets = allcarnets.filter((carnet) => {
        return isArchived(carnet, orgData) === false;
      });
    } else if (activetab === "archived") {
      allcarnets = allcarnets.filter((carnet) => {
        return isArchived(carnet, orgData) === true;
      });
    }

    // Define columns for DataGrid, customize based on your data structure
    const columns = [
      { field: "id", headerName: "ID", width: 300 },
      {
        field: "num",
        headerName: "Numéro",
        width: 100,
        renderCell: (params) => {
          const isActivated = params.row.activated;
          const code = params.value;
          if (!isActivated && code) {
            // Show only "HL-" and hide the rest
            return <span>HL-******</span>;
          }
          return <span>{code}</span>;
        }
      },

      {
        field: "name",
        headerName: "Nom",
        width: 200,
        renderCell: (params) => {
          return (
            <div
              className={`flex flex-row gap-1 items-center  h-6 ${
                params.row.all_blocked && orgData.type === "master"
                  ? "text-red-500  bg-red-100 rounded-full inline-flex  px-2 "
                  : ""
              }`}
            >
              {params.row.all_blocked && orgData.type === "master" && (
                <div className="">
                  <Icon1 icon_name="warning" size={18} fill="red"></Icon1>
                </div>
              )}
              {params.value}
            </div>
          );
        },
      },
      { field: "city", headerName: "Ville", width: 200 },

      {
        field: "creation_date",
        headerName: "Creation",
        width: 150,
        renderCell: (params) => {
          // Customize color based on status value
          const date_int = params.value;

          const date = new Date(date_int);
          return (
            <div>
              {date.toLocaleString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },

      {
        field: "state",
        headerName: "Status",
        width: 130,

        renderCell: (param) => {
          const label = param.value;
          // Customize color based on status value

          return (
            <div className="h-5">
              {label === "A venir" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-neutral-100 ">
                  {label}
                </div>
              )}
              {label === "Réalisé" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-blue-100 ">
                  {label}
                </div>
              )}
              {label === "Archivé" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-green-100 ">
                  {label}
                </div>
              )}
              {label === "Supprimé" && (
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 bg-red-100 ">
                  {label}
                </div>
              )}
            </div>
          );
        },
      },

      {
        field: "activated",
        headerName: "Status",
        width: 100,
        renderCell: (param) => {
          const label = param.value;
          // Customize color based on status value

          return (
            <div className="h-5">
              {label === true && (
                <div className="inline-flex items-center text-white rounded-full h-full px-2 py-1 bg-green-300 ">
                  Activé
                </div>
              )}
              {label === false && (
                <div className="inline-flex items-center text-shadow_25 rounded-full h-full px-2 py-1 bg-neutral-200 ">
                  Non activé
                </div>
              )}
            </div>
          );
        },
      },

      {
        field: "all_tags",
        headerName: "Tags",
        flex: 1,
        renderCell: (params) => {
          // Customize color based on status value
          const tags = params.value;
          const handleOpenTag = (e, index) => {
            e.stopPropagation();
            openTag(params.row.id, index);
          };

          if (tags) {
            const tags_me =
              tags.filter((tag) => tag.org_id === orgData.id) || null;
            if (tags_me) {
              return (
                <div className="h-full flex-wrap space-x-2">
                  {tags_me.map((tag, index) => {
                    return (
                      <div
                        onClick={(e) => handleOpenTag(e, index)}
                        key={index}
                        className="inline-flex h-5 items-center rounded-full px-2 py-1 hover:opacity-80 transition-opacity"
                        style={{
                          backgroundColor: intToHexColor(tag.colorint),
                          color: isColorTooDark(intToHexColor(tag.colorint))
                            ? "white"
                            : "black",
                        }}
                      >
                        {tag.nom}
                      </div>
                    );
                  })}
                  <div
                    onClick={(e) => handleOpenTag(e, tags_me.length)}
                    className="inline-flex h-5 items-center text-shadow_25 bg-neutral-50 hover:bg-neutral-300 hover:text-shadow_25 rounded-full px-2 py-1"
                  >
                    Ajouter
                  </div>
                </div>
              );
            }
          }

          // Empty case
          return (
            <div className="h-5">
              <div
                onClick={(e) => handleOpenTag(e, 0)}
                className="inline-flex items-center rounded-full h-full px-2 py-1 text-shadow_25 hover:bg-neutral-100 transition-colors"
              >
                Ajouter
              </div>
            </div>
          );
        },
        sortComparator: (v1, v2, params1, params2) => {
          const tag1 =
            params1.value.find((tag) => tag.org_id === orgData.id)?.nom || "z";
          const tag2 =
            params2.value.find((tag) => tag.org_id === orgData.id)?.nom || "z";
          return tag1.localeCompare(tag2); // Sorting alphabetically by the tag name
        },
      },

      {
        field: "notifs",
        headerName: "Msg",
        width: 70,
        renderCell: (params) => {
          // Customize color based on status value

          if (params.value) {
            return (
              <div className="items-center align-middle h-full inline-flex">
                <Icon1 icon_name="message"></Icon1>
              </div>
            );
          } else {
            return <></>;
          }
        },
      },

      // Add more columns as needed
    ];

    // Create rows from the clients array
    let rows = allcarnets.map((carnet, index) => ({
      id: carnet.id || index + 1, // Use client's ID or default index
      ref: carnet.ref || null, // Include client's document reference
      num: carnet.num || null, // Include client's document reference
      name: carnet.name.trim() || "", // Use client's name or default 'Unknown'
      city: carnet.city || "", // Use client's type or default
      creation_date: carnet.creation_date.seconds * 1000 || 0,
      activated: carnet.activated || false, // Use client's type or default

      state: "ok", // Use client's city or default
      // Use client's city or default
      all_tags: carnet.tags || [], // Use client's city or default
    }));
    console.log("rows", rows);

    rows = rows.sort((a, b) => {
      return a.name
        .trim()
        .toLowerCase()

        .localeCompare(b.name.toLowerCase().trim());
    });

    return { rows, columns }; // Return rows and columns for the DataGrid
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

// Transform clients into a DataGrid-friendly format
export function transformPartnersToTable(partnerss, tab = "constructor") {
  // Define columns for DataGrid, customize based on your data structure

  let partners = [...partnerss];
  if (tab === "constructor") {
    // only constructor
    partners = partners.filter(
      (partner) => partner.partner_type === "constructor"
    );
  } else if (tab === "architect") {
    // only architect
    partners = partners.filter(
      (partner) => partner.partner_type === "architect"
    );
  } else if (tab === "artisan") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "artisan");
  } else if (tab === "expert") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "expert");
  } else if (tab === "promotor") {
    // only architect
    partners = partners.filter(
      (partner) => partner.partner_type === "promotor"
    );
  } else if (tab === "mdo") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "mdo");
  } else if (tab === "drawer") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "drawer");
  } else if (tab === "other") {
    // only architect
    partners = partners.filter((partner) => partner.partner_type === "other");
  } else if (tab === "infiltro") {
    // only architect
    partners = partners.filter(
      (partner) => partner.partner_type === "infiltro"
    );
  }

  const columns = [
    { field: "id", headerName: "ID", width: 200 },

    {
      field: "name",
      headerName: "Nom",
      flex: 1,

      renderCell: (params) => {
        let payment_allowed = params.row.payment_allowed;
        let row_id = params.id;

        return (
          <div className="flex flex-row items-center">
            <div>
              <div
                className={`inline-flex h-6 border items-center rounded-lg px-2 py-2 bg-neutral-50 flex-row  font-light gap-1`}
              >
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "email", headerName: "Email", flex: 2 },

    { field: "ville", headerName: "Ville", flex: 1 },
    {
      field: "date",
      headerName: "Création",
      flex: 1,
      renderCell: (params) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = partners.map((client, index) => ({
    id: client.id || index + 1, // Use client's ID or default index
    ref: client.ref || null, // Include client's document reference
    name: client.name || "",
    email: client.email || "",
    date: client.creation_date, // Use client's creation date or default
    client_type: client.client_type || "", // Use client's type or default
    ville: client.infos?.ville || "", // Use client's city or default
  }));

  rows = rows.sort((a, b) => {
    return a.name.trim().localeCompare(b.name.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}

export function transformInvoicesToTable(
  invoices,
  theme,
  tab = "waiting",
  searchvaue = "",
  handleSendAgain,

  searchInvoices = true
) {
  // Define columns for DataGrid, customize based on your data structure
  if (searchvaue !== "") {
    if (searchInvoices) {
      invoices = invoices.filter((invoice) => invoice.nom.includes(searchvaue));
    } else {
      invoices = invoices.filter((invoice) =>
        invoice.marque.includes(searchvaue)
      );
    }
  } else {
    if (tab === "waiting") {
      invoices = invoices.filter(
        (invoice) =>
          (invoice.state === "wait" || invoice.state === "locked") &&
          (!invoice.archived || invoice.archived === undefined)
      );
    }
    if (tab === "signed") {
      invoices = invoices.filter((invoice) => invoice.state === "done");
    }
    if (tab === "archived") {
      invoices = invoices.filter((invoice) => invoice.archived);
    }
  }
  // filter invoices by tag && state

  const columns = [
    { field: "id", headerName: "Id", flex: 1 },

    { field: "nom", headerName: "Nom", flex: 1 },
    {
      field: "entreprise_name",
      headerName: "Client",
      width: 140,
      renderCell: (params) => {
        return (
          <div
            className={`inline-flex h-5 items-center rounded-full px-2 py-1 flex-row ${
              params.row.client_type === "constructor"
                ? "text-indigo-500 bg-indigo-50"
                : params.value === "Clients particuliers"
                ? "text-purple-500 bg-purple-50"
                : "text-blue-400  bg-blue-50 "
            }  font-light `}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Création",
      width: 110,
      type: "date",
    },
    {
      field: "last",
      headerName: "Dernier envoi",
      width: 140,
      renderCell: (params) => {
        let last = params.value;
        // Customize color based on status value

        return (
          <div
            className={`flex flex-col w-fit justify-center h-full ${
              last ? "text-shadow_75-400" : "text-red-400"
            }`}
          >
            {last ? new Date(last).toLocaleString() : "Pas envoyé"}
          </div>
        );
      },
    },

    { field: "phone", headerName: "Téléphone", width: 110 },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "author",
      headerName: "Origine",
      width: 120,
      renderCell: (params) => {
        let author = params.value;
        // Customize color based on status value

        return (
          <div className=" flex flex-col w-fit justify-center h-full">
            {author === "master" && (
              <div className=" flex-row px-2  flex h-6 rounded-full items-center bg-indigo-300 text-white">
                infiltromètre
              </div>
            )}
            {author === "client" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-blue-300 text-white">
                client
              </div>
            )}

            {author === "website" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-purple-300 text-white">
                site web
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "state",
      headerName: "Etat",
      width: 120,
      renderCell: (params) => {
        let state = params.value;
        // Customize color based on status value

        return (
          <div className=" flex flex-col w-fit justify-center h-full">
            {state === "locked" && (
              <div className=" flex-row px-2  flex h-6 rounded-full items-center bg-neutral-300 text-white">
                pas envoyé
              </div>
            )}
            {state === "wait" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-orange-300 text-white">
                en attente
              </div>
            )}

            {state === "done" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-green-300 text-white">
                signé
              </div>
            )}

            {state === "error" && (
              <div className="flex-row px-2  flex h-6 rounded-full items-center bg-red-300 text-white">
                erreur
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        let state = params.row.state;
        // Customize color based on status value

        return (
          <div className=" flex flex-col w-fit justify-center h-full">
            <SecondaryButton
              disabled={state === "done" ? true : false}
              onClick={(e) => {
                e.stopPropagation();
                handleSendAgain(params.row.id);
              }}
            >
              {state === "locked" ? "Envoyer" : "Renvoyer"}
            </SecondaryButton>
          </div>
        );
      },
    },

    // Add more columns as needed
  ];

  // Create rows from the clients array
  let rows = invoices.map((invoice, index) => ({
    id: invoice.id || index + 1, // Use client's ID or default index
    ref: invoice.ref || null, // Include client's document reference
    nom: invoice.nom || "", // Use client's name or default 'Unknown'
    entreprise_name: invoice.marque || "", // Use client's type or default
    creation_date: invoice.creation_date
      ? new Date(invoice.creation_date.seconds * 1000)
      : null, // Use client's city or default
    last: invoice.last_sent_seconds
      ? new Date(invoice.last_sent_seconds * 1000)
      : null, // Use client's city or default
    phone: invoice.tel_client || "", // Use client's name or default 'Unknown'

    email: invoice.email_client || "", // Use client's name or default 'Unknown'

    state: invoice.state || "", // Use client's city or default
    client_type: invoice.client_type || "architect",
    author: invoice.author || "", // Use client's city or default
  }));

  rows = rows.sort((a, b) => {
    return a.nom.trim().localeCompare(b.nom.trim());
  });

  return { rows, columns }; // Return rows and columns for the DataGrid
}

// Transform orgs into a DataGrid-friendly format
export function transformOrgsToTable(orgs, filter_type = null) {
  let filteredOrgs = orgs;

  if (filter_type) {
    filteredOrgs = orgs.filter((org) => org.type === filter_type);
  }

  const columns = [
    { field: "id", headerName: "ID", width: 200 },
    {
      field: "name",
      headerName: "Nom",
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="flex flex-row items-center">
            <div>
              <div className="inline-flex h-6 items-center rounded-full px-2 py-1 flex-row bg-indigo-50 text-indigo-500 font-light gap-1">
                <span className="whitespace-nowrap">{params.value}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "type", headerName: "Type", width: 100 },
    { field: "credits", headerName: "Crédits", width: 100 },
    {
      field: "creation_date",
      headerName: "Création",
      width: 150,
      renderCell: (params) => {
        const date = params.value;
        return (
          <div className="flex flex-row items-center">
            {date && new Date(date.seconds * 1000).toLocaleString()}
          </div>
        );
      },
    },
  ];

  const rows = filteredOrgs.map((org, index) => ({
    id: org.id || index + 1,
    ref: org.ref || null,
    name: org.name || "",
    email: org.email || "",
    type: org.type || "",
    credits: org.logement?.facturation?.credits || 0,
    creation_date: org.creation_date || null,
  }));

  return { rows, columns };
}
